var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactSubPage',{attrs:{"title":{ 'zh-CN': '营销中心', 'en-US': 'Marketing Center' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }